import { ApiService } from "../..";

export const removeGroupLeaderRole = (query: {
  username?: string;
  id?: string;
  phoneNumber?: string;
}) => {
  return ApiService.baseAction(
    "user/group_leader",
    {
      data: { query },
    },
    "delete"
  );
};
